import Dashboard from '../../../../../baseComponents/Dashboard'
import { getEmployeeParams } from '../../../../../utils/reducers/getters'


const CompanyDashboard: React.FC = () => {
    const defaultStyle = getEmployeeParams()?.['appStyle'] || 'new1'
    const defaultWidgets = {
        default: [{ "cols": 1, "rows": 2, "name": "sue_status_expired" }, { "cols": 1, "rows": 2, "name": "sue_status_informed" }, { "cols": 2, "rows": 4, "name": "sue_bar_chart" }, { "cols": 1, "rows": 2, "name": "sue_status_processed" }, { "cols": 1, "rows": 2, "name": "sue_status_closed" }],
        new1: [{ "cols": 3, "rows": 4, "name": "sue_bar_chart" }, { "cols": 1, "rows": 2, "name": "sue_status_expired" }, { "cols": 1, "rows": 2, "name": "sue_status_informed" }, { "cols": 1, "rows": 2, "name": "sue_status_closed" }, { "cols": 1, "rows": 2, "name": "sue_status_processed" }]
    }
    
    const props = {
        name: 'dashboard_distribution',
        defaultWidgets: JSON.stringify(defaultWidgets[defaultStyle])
    }
    return (<Dashboard {...props} />)
}

export default CompanyDashboard